
<template>
  <v-container>
      
          

    <v-sheet
  color="white"
   elevation="5"
  height="200"
  width="400"
>
<h2>Email Settings</h2>

 <v-select
          :items="items"
          label="Select a template"
          hint="Email for remind users that have not select a plan"
           persistent-hint
          outlined
        ></v-select>

</v-sheet>
  </v-container>
</template>

<script>
import { postReq} from '../helper/firestore'
export default {
    data(){
        return{
            items : [],
            templateList : [],
        }
    },
    mounted(){
       postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/getEmailTemplate',{},(res)=>{
            this.templateList = res.data;
        })
    },
}
</script>

<style>

</style>